import { render } from "./TestPage.vue?vue&type=template&id=5d6ad2ef"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"

import "./TestPage.vue?vue&type=style&index=0&id=5d6ad2ef&lang=css"

import exportComponent from "D:\\git\\Homepage\\vue3home\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__